import { useIntl } from 'bundles/page/lib/useIntl';

import _t from 'i18n!nls/program-loggedin-shared';

export const useCategoryCompletionRule = (minUnits: number) => {
  const intl = useIntl();
  return intl.formatMessage(_t('Complete {minUnits} {minUnits, plural, =1 { segment} other { segments}}'), {
    minUnits,
  });
};

export const useSegmentCompletionRule = (minUnits: number) => {
  const intl = useIntl();
  return intl.formatMessage(_t('{minUnits} {minUnits, plural, =1 { credit} other { credits}} required'), { minUnits });
};
